import { __extends } from "tslib";
import { removeAllChildren, removeElement } from '@tyler-components-web/core';
import { matchesSelectors } from 'shadow-utils';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { attachTooltip } from './tooltip-utils';
/**
 * The DOM adapter for the tooltip component.
 */
var TooltipAdapter = /** @class */ (function (_super) {
    __extends(TooltipAdapter, _super);
    function TooltipAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._tooltipElement = null;
        return _this;
    }
    TooltipAdapter.prototype.initializeTargetElement = function (selector) {
        this._targetElement = this._getTargetElement(selector);
    };
    TooltipAdapter.prototype.initializeAccessibility = function (identifier) {
        if (this._targetElement && !this._targetElement.hasAttribute('aria-describedby')) {
            this._targetElement.setAttribute('aria-describedby', identifier);
        }
    };
    TooltipAdapter.prototype.hasTargetElement = function () {
        return !!this._targetElement;
    };
    TooltipAdapter.prototype.hasTooltipElement = function () {
        return !!this._tooltipElement;
    };
    TooltipAdapter.prototype.isTargetElementConnected = function () {
        return !!this._targetElement && this._targetElement.isConnected;
    };
    TooltipAdapter.prototype.destroy = function (identifier) {
        if (this._targetElement && this._targetElement.getAttribute('aria-describedby') === identifier) {
            this._targetElement.removeAttribute('aria-describedby');
        }
    };
    /**
     * Sets the text content of the host element to the provided text.
     * @param text The text content.
     */
    TooltipAdapter.prototype.setTextContent = function (text) {
        removeAllChildren(this._component);
        if (text) {
            this._component.appendChild(document.createTextNode(text));
        }
    };
    /**
     * Adds an event listener to the target element.
     * @param targetElement The target element instance.
     * @param type The event type.
     * @param listener The event listener.
     */
    TooltipAdapter.prototype.addTargetEventListener = function (type, listener) {
        if (this._targetElement) {
            this._targetElement.addEventListener(type, listener);
        }
    };
    /**
     * Removes an event listener from the target element.
     * @param type The event type.
     * @param listener The event listener.
     */
    TooltipAdapter.prototype.removeTargetEventListener = function (type, listener) {
        if (this._targetElement) {
            this._targetElement.removeEventListener(type, listener);
        }
    };
    /**
     * Displays the tooltip around the target element based on the provided configuration.
     * @param position The position.
     * @param content The tooltip content.
     */
    TooltipAdapter.prototype.showTooltip = function (position, content) {
        if (!this._targetElement) {
            return;
        }
        if (!content) {
            var child = this._getTooltipContent();
            content = child.cloneNode(true);
        }
        var isEmptyTextNode = content.nodeType === 3 && (!content.textContent || content.textContent.trim().length === 0);
        var isEmptyNode = !content || isEmptyTextNode;
        if (isEmptyNode) {
            return;
        }
        this._tooltipElement = attachTooltip(this._targetElement, position, content);
    };
    TooltipAdapter.prototype.getInnerText = function () {
        return this._component.innerText;
    };
    /**
     * Removes the tooltip from the DOM.
     * @param tooltipElement The target element instance.
     */
    TooltipAdapter.prototype.hideTooltip = function () {
        if (this._tooltipElement) {
            removeElement(this._tooltipElement);
            this._tooltipElement = null;
        }
    };
    TooltipAdapter.prototype.getTooltipElement = function () {
        return this._tooltipElement;
    };
    /**
     * Gets the target element based on the provided CSS selector.
     * @param {string | undefined} selector The target element selector.
     */
    TooltipAdapter.prototype._getTargetElement = function (selector) {
        if (selector) {
            if (this._component.parentElement) {
                if (matchesSelectors(this._component.parentElement, selector)) {
                    return this._component.parentElement;
                }
                return this._component.parentElement.querySelector(selector);
            }
        }
        else {
            return (this._component.previousElementSibling || this._component.parentElement);
        }
        return null;
    };
    TooltipAdapter.prototype._getTooltipContent = function () {
        return this._component.firstElementChild || this._component.firstChild || document.createTextNode('');
    };
    return TooltipAdapter;
}(BaseAdapter));
export { TooltipAdapter };
